import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import download from 'downloadjs';
import moment from 'moment'
import binMultiselectFilterMixin from '../shared/binMultiselectFilterMixin';

const BIN_TYPE_OPTIONS = [
	{ text: 'Rack', value: 0 },
	{ text: 'Floor', value: 1 },
	{ text: 'Pigeon Hole', value: 2 }
];
const HUBOPS_AUTH_HEADERS = { authorization: 'authkey xB84JJ89Hd25' };

function toSelectOptions(items) {
	return (items || []).map((item) => ({
		text: String(item),
		value: String(item)
	}));
}

function selectedFilterValues(selected) {
	if (!selected || !selected.length) {
		return null;
	}
	return selected.map((item) => item.value);
}

function appendCsvQueryParam(url, key, values) {
	if (!values || !values.length) {
		return url;
	}
	return url + '&' + key + '=' + encodeURIComponent(values.join(','));
}

export default {
	name: 'Palletization_Masters',
	mixins: [binMultiselectFilterMixin],
	components: {
		VueElementLoading,
		download,
		Paginate,
		Multiselect
	},
	props: [],
	data() {
		return {
			hubid:'',
			hubName:'',
      failed: [],
      isLoading: false,
      createdby:'',
      configFile:'',
			currentTab: 'palletUpload',
			tabs: [
				{
					key: 'palletUpload',
					value: 'Palletization [Bin/ Pallet] Upload'
				},
				{
					key: 'palletConfig',
					value: 'CutOff Config'
				}
			],
			palletFailed: [],
			palletConfigList: [],
			editIndex: -1,
			editRow: {},
			isdisableupload: true,
			binPanel: {
				list: [],
				totalRows: 0,
				pageCount: 0,
				pageno: 0,
				limit: 10,
				filters: {
					sector: [],
					row: [],
					type: [],
					status: 'true',
					sectorOptions: [],
					rowOptions: [],
					typeOptions: BIN_TYPE_OPTIONS
				},
				edit: { index: -1, row: {} }
			}
		}
	},
	filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes 						= CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext 				= bytes.toString(CryptoJS.enc.Utf8);
		var userdetail 				= JSON.parse(plaintext);
		this.hubid 						= userdetail[0].HubId[0];
		this.createdby 				= userdetail[0].email;

		this.getHubName(this.hubid);
		this.refreshBinPanel({ filters: true, list: true });
	},
	methods: {

		switchTab(tab) {
			this.currentTab = tab.key;
			if (tab.key === 'palletUpload') {
				this.resetPalletForm();
				this.refreshBinPanel({ filters: true, list: true });
			} else if (tab.key === 'palletConfig') {
				this.reset();
				this.getPalletConfigList();
			}
		},

		getHubName(hubid) {
			this.isLoading = true;
			this.hubName = '';
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName
          }
					this.isLoading = false;
        }, error => {
					this.isLoading = false;
          console.error(error)
        })
    },

		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },

		export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

		//function is used read palletization config file
    readConfigFile(event){

			if(!this.hubid || !this.hubName){
				this.$alertify.error("Error: Logged-In hub should not be empty!"); return false;
			}

			this.failed = [];
			this.isLoading = true;

      this.selectedFile = event.target[0].files[0];

			if(this.selectedFile.size>5242880){
				this.isLoading = false;
        this.$alertify.error("Failed! Upload Max File Size Should Not Be Greater Than 5 MB"); return false;
      }else if ( /\.(csv)$/i.test(this.selectedFile.name) ){

        const fd = new FormData();
        fd.append('currentHubId', this.hubid);
        fd.append('currentHubName', this.hubName);
        fd.append('lastModifiedBy', this.createdby);
        fd.append('file', this.selectedFile);

        axios.post(apiUrl.api_url_hubops + 'readConfigFile', fd,
        {
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {

          if(result.data.ResultCode == 100){
            this.$alertify.success(result.data.ReturnMessage);
            if(result && result.data.failed.length > 0){
              this.failed = result.data.failed;
            }
            this.refreshBinPanel({ filters: true, list: true });
            return;
          }
          this.$alertify.error(result.data.ReturnMessage);
          if(result && result.data.failed.length > 0){
            this.failed = result.data.failed;
          }
          this.isLoading = false;
        }, error => {
          console.error(error)
          this.isLoading = false;
          this.$alertify.error('Error Occured');
        });
      }else{
        this.isLoading = false;
        this.$alertify.error("Failed! Please Upload Only Valid Format: .csv");
      }
    },

		onSubmit: function(res) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.readConfigFile(event)
          event.target.reset();
       }else{
				 this.isLoading = false;
			 }
      }).catch(() => {
				this.isLoading = false;
        this.$alertify.error('Error Occured');
      });
    },

		async exportFailedConfig() {
     this.isLoading = true;

		 let csvFields = {};
		 let fileName = '';

		 if(this.failed[0].Bin_ID){
			 fileName = 'failedConfig_Bin';
	     csvFields = {
	       'Bin_ID': 'Bin_ID',
	       'Type': 'Type',
	       'Length': 'Length',
	       'Breadth': 'Breadth',
	       'Height': 'Height',
	       'Max_Volumentric_Weight': 'Max_Volumentric_Weight',
	       'Max_Physical_Weight': 'Max_Physical_Weight',
	       'Max_Pallets': 'Max_Pallets',
	       'Status': 'Status',
				 'Reason': 'Reason'
	     }
		 }else{
			 fileName = 'failedConfig_Pallet';
			 csvFields = {
	       'Pallet_ID': 'Pallet_ID',
	       'Type': 'Type',
	       'Max_Physical_Weight': 'Max_Physical_Weight',
	       'Status': 'Status',
				 'Reason': 'Reason'
	     }
		 }

     await this.jsonToCSV(fileName, this.failed, csvFields);
     this.isLoading = false;
   },

    reset(event){
      this.isLoading = false;
			this.failed = [];
      this.$validator.reset();
      this.errors.clear();
    },

	refreshBinPanel({ filters = false, list = false } = {}) {
		if (filters) {
			this.loadBinFilterOptions();
		}
		if (list) {
			this.fetchBinList();
		}
	},

	loadBinFilterOptions() {
		const panelFilters = this.binPanel.filters;
		this.binPicker.loading = 'Loading bin numbers...';

		let binUrl = apiUrl.api_url_hubops +
			'getBinMasterFilterOptions?currentHubId=' + this.hubid;
		binUrl = appendCsvQueryParam(binUrl, 'bintype', selectedFilterValues(panelFilters.type));

		axios({
			method: 'GET',
			url: apiUrl.api_url_hubops + 'getUploadedBinSectorsRows?currentHubId=' + this.hubid,
			headers: HUBOPS_AUTH_HEADERS
		})
		.then((sectorResult) => {
			if (sectorResult.data.ResultCode == 100 && sectorResult.data.ResponseData) {
				panelFilters.sectorOptions = toSelectOptions(sectorResult.data.ResponseData.Sector);
				panelFilters.rowOptions = toSelectOptions(sectorResult.data.ResponseData.Row);
			} else {
				panelFilters.sectorOptions = [];
				panelFilters.rowOptions = [];
			}
		}, (error) => {
			console.error(error);
			panelFilters.sectorOptions = [];
			panelFilters.rowOptions = [];
		});

		axios({
			method: 'GET',
			url: binUrl,
			headers: HUBOPS_AUTH_HEADERS
		})
		.then((result) => {
			if (result.data.ResultCode == 100) {
				this.binPicker.options = (result.data.ResponseData || []).map((row) => ({
					text: row.binnumber,
					value: row.binnumber
				}));
			} else {
				this.binPicker.options = [];
			}
			this.binPicker.loading = '';
		}, (error) => {
			console.error(error);
			this.binPicker.options = [];
			this.binPicker.loading = '';
		});
	},

	buildBinListQuery(downloadAll) {
		const panel = this.binPanel;
		const filters = panel.filters;
		let url = apiUrl.api_url_hubops +
			'getBinMasterList?currentHubId=' + this.hubid +
			'&limit=' + panel.limit +
			'&offset=' + (panel.pageno * panel.limit);

		url = appendCsvQueryParam(url, 'sector', selectedFilterValues(filters.sector));
		url = appendCsvQueryParam(url, 'row', selectedFilterValues(filters.row));
		url = appendCsvQueryParam(url, 'bintype', selectedFilterValues(filters.type));
		if (filters.status) {
			url += '&isActive=' + filters.status;
		}

		const binNumbers = this.binPickerSelectedValues();
		if (binNumbers && binNumbers.length > 0) {
			url += '&binNumbers=' + encodeURIComponent(binNumbers.join(','));
		}
		if (downloadAll) {
			url += '&downloadAll=true';
		}
		return url;
	},

	editBinRow(index) {
		const data = this.binPanel.list[index];
		this.binPanel.edit = {
			index,
			row: {
				binid: data.binid,
				bintype: Number(data.bintype),
				binlength: data.binlength,
				binbreadth: data.binbreadth,
				binheight: data.binheight,
				binmaxvolumetriccapacity: data.binmaxvolumetriccapacity,
				binmaxphysicalcapacity: data.binmaxphysicalcapacity,
				maxnoofpallets: data.maxnoofpallets,
				sector: data.sector || '',
				row: data.row || '',
				isActive: data.isactive !== false
			}
		};
	},

	cancelEditBinRow() {
		this.binPanel.edit = { index: -1, row: {} };
	},

	saveBinRow() {
		const editRow = this.binPanel.edit.row;
		this.isLoading = true;
		const input = {
			binId: editRow.binid,
			currentHubId: this.hubid,
			lastModifiedBy: this.createdby,
			bintype: Number(editRow.bintype),
			binlength: editRow.binlength === '' || editRow.binlength == null ? null : Number(editRow.binlength),
			binbreadth: editRow.binbreadth === '' || editRow.binbreadth == null ? null : Number(editRow.binbreadth),
			binheight: editRow.binheight === '' || editRow.binheight == null ? null : Number(editRow.binheight),
			binmaxvolumetriccapacity: editRow.binmaxvolumetriccapacity === '' || editRow.binmaxvolumetriccapacity == null
				? null : Number(editRow.binmaxvolumetriccapacity),
			binmaxphysicalcapacity: editRow.binmaxphysicalcapacity === '' || editRow.binmaxphysicalcapacity == null
				? null : Number(editRow.binmaxphysicalcapacity),
			maxnoofpallets: editRow.maxnoofpallets === '' || editRow.maxnoofpallets == null
				? null : parseInt(editRow.maxnoofpallets, 10),
			sector: editRow.sector || '',
			row: editRow.row || '',
			isActive: editRow.isActive === true || editRow.isActive === 'true'
		};
		axios({
			method: 'POST',
			url: apiUrl.api_url_hubops + 'updateBinMaster',
			data: input,
			headers: HUBOPS_AUTH_HEADERS
		})
		.then((result) => {
			if (result.data.ResultCode == 100) {
				this.$alertify.success(result.data.ReturnMessage);
				this.cancelEditBinRow();
				this.refreshBinPanel({ filters: true, list: true });
				return;
			}
			this.$alertify.error(result.data.ReturnMessage);
			this.isLoading = false;
		}, (error) => {
			this.isLoading = false;
			console.error(error);
			this.$alertify.error('Error Occured');
		});
	},

	fetchBinList() {
		this.isLoading = true;
		this.binPanel.edit = { index: -1, row: {} };
		axios({
			method: 'GET',
			url: this.buildBinListQuery(false),
			headers: HUBOPS_AUTH_HEADERS
		})
		.then((result) => {
			if (result.data.ResultCode == 100) {
				this.binPanel.list = result.data.ResponseData;
				this.binPanel.totalRows = result.data.pagination.totalCount;
				this.binPanel.pageCount = result.data.pagination.totalPages;
			} else if (result.data.ResultCode == 101) {
				this.binPanel.list = [];
				this.binPanel.totalRows = 0;
				this.binPanel.pageCount = 0;
			} else {
				this.$alertify.error(result.data.ReturnMessage);
			}
			this.isLoading = false;
		}, (error) => {
			this.isLoading = false;
			console.error(error);
		});
	},

	getBinPaginationData(pageNum) {
		this.binPanel.pageno = pageNum - 1;
		this.fetchBinList();
	},

	applyBinFilters() {
		this.binPanel.pageno = 0;
		this.fetchBinList();
	},

	resetBinFilters() {
		const filters = this.binPanel.filters;
		filters.sector = [];
		filters.row = [];
		filters.type = [];
		filters.status = 'true';
		this.binPickerReset();
		this.binPanel.pageno = 0;
		this.refreshBinPanel({ filters: true, list: true });
	},

	async downloadBinConfigList() {
		this.isLoading = true;
		try {
			const result = await axios({
				method: 'GET',
				url: this.buildBinListQuery(true),
				headers: HUBOPS_AUTH_HEADERS
			});
			if (result.data.ResultCode != 100) {
				this.$alertify.error(result.data.ReturnMessage || 'No data to download.');
				this.isLoading = false;
				return;
			}
			const csvData = (result.data.ResponseData || []).map((row) => ({
				Bin_ID: row.binnumber,
				Type: row.bintypeLabel,
				Length: row.binlength,
				Breadth: row.binbreadth,
				Height: row.binheight,
				Max_Volumentric_Weight: row.binmaxvolumetriccapacity,
				Max_Physical_Weight: row.binmaxphysicalcapacity,
				Max_Pallets: row.maxnoofpallets,
				Sector: row.sector || '',
				Row: row.row || '',
				Status: row.isactive !== false ? 'Active' : 'Inactive',
				Created_By: row.createdby,
				Created_Date: row.createddate,
				Last_Modified_By: row.lastmodifiedby || '',
				Last_Modified_Date: row.lastmodifieddate || ''
			}));
			const csvFields = {
				Bin_ID: 'Bin_ID',
				Type: 'Type',
				Length: 'Length',
				Breadth: 'Breadth',
				Height: 'Height',
				Max_Volumentric_Weight: 'Max_Volumentric_Weight',
				Max_Physical_Weight: 'Max_Physical_Weight',
				Max_Pallets: 'Max_Pallets',
				Sector: 'Sector',
				Row: 'Row',
				Status: 'Status',
				Created_By: 'Created_By',
				Created_Date: 'Created_Date',
				Last_Modified_By: 'Last_Modified_By',
				Last_Modified_Date: 'Last_Modified_Date'
			};
			const safeHub = String(this.hubName || this.hubid).replace(/\s+/g, '_');
			await this.jsonToCSV('bin_config_' + safeHub, csvData, csvFields, ['Created_Date', 'Last_Modified_Date']);
		} catch (error) {
			console.error(error);
			this.$alertify.error('Error Occured');
		}
		this.isLoading = false;
	},

	// Sample CSV template for Bin Config upload
	downloadBinConfigTemplate() {
		const csvFields = {
			"Bin_ID": "Bin_ID",
			"Type": "Type",
			"Length": "Length",
			"Breadth": "Breadth",
			"Height": "Height",
			"Max_Volumentric_Weight": "Max_Volumentric_Weight",
			"Max_Physical_Weight": "Max_Physical_Weight",
			"Max_Pallets": "Max_Pallets",
			"Sector": "Sector",
			"Row": "Row",
			"Status": "Status",
		};
		const sampleData = [
			{
				"Bin_ID": "R1-V1-L1",
				"Type": "Rack",
				"Length": "",
				"Breadth": "",
				"Height": "",
				"Max_Volumentric_Weight": "",
				"Max_Physical_Weight": "",
				"Max_Pallets": "",
				"Sector": "Kalyani",
				"Row": "R1",
				"Status": "Active"
			},
			{
				"Bin_ID": "P1-V1-L1",
				"Type": "Pigeon Hole",
				"Length": "",
				"Breadth": "",
				"Height": "",
				"Max_Volumentric_Weight": "",
				"Max_Physical_Weight": "",
				"Max_Pallets": "",
				"Sector": "P001",
				"Row": "P1",
				"Status": "Active"
			},
			{
				"Bin_ID": "F1-L1",
				"Type": "Floor",
				"Length": "",
				"Breadth": "",
				"Height": "",
				"Max_Volumentric_Weight": "",
				"Max_Physical_Weight": "",
				"Max_Pallets": "",
				"Sector": "Viman",
				"Row": "R22",
				"Status": "Inactive"
			}
		];
		this.jsonToCSV("bin_config_template", sampleData, csvFields);
	},

		// ===== Pallet Config Methods =====

		uploadCameraConfigFile(file) {
			if(this.isdisableupload) {
				this.$alertify.error("You are not authorized to upload this config.");
				return;
			}

			this.palletFailed = [];
			this.selectedFile = file;

			if (this.selectedFile.size > 5242880) {
				this.$alertify.error("Failed! Upload Max File Size Should Not Be Greater Than 5 MB");
				return false;
			} else if (/\.(csv)$/i.test(this.selectedFile.name)) {
				this.isLoading = true;

				const fd = new FormData();
				fd.append('currentHubId', this.hubid);
				fd.append('currentHubName', this.hubName);
				fd.append('lastModifiedBy', this.createdby);
				fd.append('file', this.selectedFile);

				axios.post(apiUrl.api_url_hubops + 'uploadCutoffPalletConfig', fd, {
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage);
						this.resetPalletForm();
						this.getPalletConfigList();
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}

					if (result && result.data.failed && result.data.failed.length > 0) {
						this.palletFailed = result.data.failed;
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
					this.isLoading = false;
					this.$alertify.error('Error Occured');
				});
			} else {
				this.isLoading = false;
				this.$alertify.error("Failed! Please Upload Only Valid Format: .csv");
			}
		},

		onpalletUploadSubmit: function(res) {
			var fileInput = document.getElementById('palletConfigFile');
			var file = fileInput && fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;

			// File inputs are unreliable with vee-validate required alone; set error bag explicitly
			if (!file) {
				this.errors.remove('palletConfigFile');
				this.errors.add({
					field: 'palletConfigFile',
					msg: 'Upload file is required.'
				});
				this.isLoading = false;
				return;
			}

			this.errors.remove('palletConfigFile');
			this.uploadCameraConfigFile(file);
			if (fileInput) fileInput.value = '';
		},

		clearPalletConfigFileError() {
			if (this.errors.has('palletConfigFile')) {
				this.errors.remove('palletConfigFile');
			}
		},

		async exportPalletFailedConfig() {
			this.isLoading = true;

			let fileName = "failedPalletConfig";
			let csvFields = {
				"Facility Name": "Facility Name",
				"LM": "LM",
				"FM": "FM",
				"MM": "MM",
				"Hours": "Hours",
				"Type": "Type",
				"Reason": "Reason"
			};

			await this.jsonToCSV(fileName, this.palletFailed, csvFields);
			this.isLoading = false;
		},

		// HUB-8078: sample CSV template for CutOff Config upload
		downloadCutoffTemplate() {
			const csvFields = {
				"Facility Name": "Facility Name",
				"LM": "LM",
				"FM": "FM",
				"MM": "MM",
				"Hours": "Hours",
				"Type": "Type"
			};
			const facility =  "PNQ/Dummy";
			const sampleData = [
				{
					"Facility Name": facility,
					"LM": "Yes",
					"FM": "No",
					"MM": "Yes",
					"Hours": 4,
					"Type": "MPS"
				},
				{
					"Facility Name": facility,
					"LM": "Yes",
					"FM": "No",
					"MM": "Yes",
					"Hours": 2,
					"Type": "PW"
				}
			];
			this.jsonToCSV("cutoff_config_template", sampleData, csvFields);
		},

		resetPalletForm() {
			this.isLoading = false;
			this.palletFailed = [];
			this.$validator.reset();
			this.errors.clear();
		},

		getPalletConfigList() {
			this.isLoading = true;
			this.palletConfigList = [];
			this.editIndex = -1;
			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getCutoffPalletConfig?hubId=' + this.hubid + '&useremail=' + this.createdby,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25'
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.palletConfigList = result.data.ResponseData;
				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
				
				this.isdisableupload = result.data.isdisableupload;
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
				console.error(error);
			})
		},

		editPalletRow(index) {
			this.editIndex = index;
			this.editRow = {
				eligible_lm: this.palletConfigList[index].eligible_lm,
				eligible_fm: this.palletConfigList[index].eligible_fm,
				eligible_mm: this.palletConfigList[index].eligible_mm,
				cutoff_hours: Number(this.palletConfigList[index].cutoff_hours)
			};
		},

		cancelEditPalletRow() {
			this.editIndex = -1;
			this.editRow = {};
		},

		savePalletRow(index) {
			if (this.isdisableupload) {
				this.$alertify.error("You are not authorized to edit this config.");
				return;
			}

			var data = this.palletConfigList[index];
			this.isLoading = true;
			var input = {
				hubId: this.hubid,
				facilityName: data.facilityname,
				eligible_lm: this.editRow.eligible_lm,
				eligible_fm: this.editRow.eligible_fm,
				eligible_mm: this.editRow.eligible_mm,
				cutoff_hours: parseInt(this.editRow.cutoff_hours),
				lastModifiedBy: this.createdby
			};
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'updateCutoffPalletConfig',
				data: input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25'
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage);
					this.getPalletConfigList();
				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.editIndex = -1;
				this.editRow = {};
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
				console.error(error);
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/Palletization/Masters/Masters.js